import React from "react";

const Close = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="12.452" height="12.452" viewBox="0 0 12.452 12.452">
        <path id="xmark-solid_7_" data-name="xmark-solid (7)" d="M44.008,98.051a1.246,1.246,0,0,0-1.762-1.762l-4.1,4.1-4.1-4.1a1.246,1.246,0,0,0-1.762,1.762l4.1,4.1-4.1,4.1a1.246,1.246,0,1,0,1.762,1.762l4.1-4.1,4.1,4.1a1.246,1.246,0,1,0,1.762-1.762l-4.1-4.1Z" transform="translate(-31.925 -95.925)" fill="currentColor"/>
    </svg>
}

export default Close;
